import { Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

type DeletePresentationVideoModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  onConfirmDelete: () => void;
};

const DeletePresentationVideoModalComponent: React.FC<DeletePresentationVideoModalProps> = ({ isOpen, onClose, onConfirmDelete }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-26">{t("do-you-really-want-to-delete-your-video")}</Typography.Text>
        </div>
        <div className="bottom-modal-body">
          <button className="bottom-modal-button" onClick={onConfirmDelete}>
            <Typography.Text className="bottom-modal-button-title">{t("delete-video")}</Typography.Text>
          </button>

          <button className="bottom-modal-cancel-button" onClick={onClose}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePresentationVideoModalComponent;
